import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <UserNav::MessagesSecondaryNav>

  <DNavigationItem
    @route="userPrivateMessages.group.index"
    @ariaCurrentContext="subNav"
    class="user-nav__messages-group-latest"
  >
    {{d-icon "envelope"}}
    <span>{{i18n "categories.latest"}}</span>
  </DNavigationItem>

  {{#if this.viewingSelf}}
    <DNavigationItem
      @route="userPrivateMessages.group.new"
      @ariaCurrentContext="subNav"
      class="user-nav__messages-group-new"
    >
      {{d-icon "exclamation-circle"}}
      <span>{{this.newLinkText}}</span>
    </DNavigationItem>

    <DNavigationItem
      @route="userPrivateMessages.group.unread"
      @ariaCurrentContext="subNav"
      class="user-nav__messages-group-unread"
    >
      {{d-icon "plus-circle"}}
      <span>{{this.unreadLinkText}}</span>
    </DNavigationItem>

    <DNavigationItem
      @route="userPrivateMessages.group.archive"
      @ariaCurrentContext="subNav"
      class="user-nav__messages-group-archive"
    >
      {{d-icon "archive"}}
      <span>{{i18n "user.messages.archive"}}</span>
    </DNavigationItem>
  {{/if}}
</UserNav::MessagesSecondaryNav>

{{#in-element this.navigationControlsButton}}
  <GroupNotificationsButton
    @value={{this.group.group_user.notification_level}}
    @onChange={{this.changeGroupNotificationLevel}}
  />
{{/in-element}}

<div class="group-messages group-{{this.group.name}}">
  {{outlet}}
</div>
*/
{
  "id": "djOfzXTR",
  "block": "[[[8,[39,0],null,null,[[\"default\"],[[[[1,\"\\n\\n  \"],[8,[39,1],[[24,0,\"user-nav__messages-group-latest\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userPrivateMessages.group.index\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,2],[\"envelope\"],null]],[1,\"\\n    \"],[10,1],[12],[1,[28,[35,3],[\"categories.latest\"],null]],[13],[1,\"\\n  \"]],[]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"viewingSelf\"]],[[[1,\"    \"],[8,[39,1],[[24,0,\"user-nav__messages-group-new\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userPrivateMessages.group.new\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,2],[\"exclamation-circle\"],null]],[1,\"\\n      \"],[10,1],[12],[1,[30,0,[\"newLinkText\"]]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[39,1],[[24,0,\"user-nav__messages-group-unread\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userPrivateMessages.group.unread\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,2],[\"plus-circle\"],null]],[1,\"\\n      \"],[10,1],[12],[1,[30,0,[\"unreadLinkText\"]]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[39,1],[[24,0,\"user-nav__messages-group-archive\"]],[[\"@route\",\"@ariaCurrentContext\"],[\"userPrivateMessages.group.archive\",\"subNav\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,2],[\"archive\"],null]],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,3],[\"user.messages.archive\"],null]],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],null]],[]]]]],[1,\"\\n\\n\"],[40,[[[1,\"  \"],[8,[39,7],null,[[\"@value\",\"@onChange\"],[[30,0,[\"group\",\"group_user\",\"notification_level\"]],[30,0,[\"changeGroupNotificationLevel\"]]]],null],[1,\"\\n\"]],[]],\"%cursor:0%\",[28,[37,6],[[30,0,[\"navigationControlsButton\"]]],null]],[1,\"\\n\"],[10,0],[15,0,[29,[\"group-messages group-\",[30,0,[\"group\",\"name\"]]]]],[12],[1,\"\\n  \"],[46,[28,[37,9],null,null],null,null,null],[1,\"\\n\"],[13]],[],false,[\"user-nav/messages-secondary-nav\",\"d-navigation-item\",\"d-icon\",\"i18n\",\"if\",\"in-element\",\"-in-el-null\",\"group-notifications-button\",\"component\",\"-outlet\"]]",
  "moduleName": "discourse/templates/user-private-messages-group.hbs",
  "isStrictMode": false
});